import gql from 'graphql-tag';

export const fields = `
    tenantId
    username
    password
    hasFileManagerChatbot
    hasSqlChatbot
    tenant {
        id
        name
        code
        isActive
    }
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateCompanies (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateCompanies (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetCompanies (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetCompanies (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindCompanyById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindCompanyById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindCompanyByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryPaginateOperators: QueryStatement
        $constraintPaginateOperators: QueryStatement
        $queryGetFleets: QueryStatement
        $constraintGetFleets: QueryStatement
    ) {
        object: digitaiFindCompanyById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateOperators (
            query: $queryPaginateOperators
            constraint: $constraintPaginateOperators
        ) {
            total
            rows
            count
        }
        digitaiGetFleets (
            query: $queryGetFleets
            constraint: $constraintGetFleets
        ) {
            id
            aircraftModel {
                id
                name
                totalMotors
            }
            engineModel {
                id
                name
            }
        }
        ${relationsFields}
    }
`;

export const findQuery = gql`
    query DigitaiFindCompany (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindCompany (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateCompany (
        $payload: DigitaiCreateCompanyInput!
    ) {
        digitaiCreateCompany (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateCompanies (
        $payload: [DigitaiCreateCompanyInput]!
    ) {
        digitaiCreateCompanies (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateCompanyById (
        $payload: DigitaiUpdateCompanyByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateCompanyById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateCompanies (
        $payload: DigitaiUpdateCompaniesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateCompanies (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteCompanyById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteCompanyById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteCompanies (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteCompanies (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

// Queries additionalApis
export const meCompanyQuery = gql`
    query DigitaiMeCompany {
        digitaiMeCompany {
            ${fields}
        }
    }
`;
